<div >
  <div class="d-flex  justify-content-between">
    <div mat-card-title>Sale LKR</div>
  <div class="d-flex align-items-center me-3">
    <p class="text-muted mb-0 me-1">From</p>
    <nz-date-picker class="me-2" [nzDisabledDate]="disabledStartDate" nzSize="default" [(ngModel)]="startValue"
      nzPlaceHolder="Start" (ngModelChange)="onDateAdded()"
      (nzOnOpenChange)="handleStartOpenChange($event)"></nz-date-picker>

    <p class="text-muted mb-0 me-1">To</p>
    <nz-date-picker #endDatePicker [nzDisabledDate]="disabledEndDate" nzSize="default" [(ngModel)]="endValue"
      (ngModelChange)="onDateAdded()" nzPlaceHolder="End"></nz-date-picker>
  </div>
  </div>

  <div>
    <div class="chart-container pt-3" style="width: 100%; height: 300px;">
      <canvas id="myChart"></canvas>
    </div>

  </div>
</div>
